import { render, staticRenderFns } from "./WIP.vue?vue&type=template&id=1544143e&"
import script from "./WIP.vue?vue&type=script&lang=js&"
export * from "./WIP.vue?vue&type=script&lang=js&"
import style0 from "./WIP.vue?vue&type=style&index=0&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports